var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.hideSidebar)?_c('SideBar'):_vm._e(),_c('div',{staticClass:"router-wrapper"},[_c('RouterView',{key:_vm.$route.path,class:{'container': !['login', 'forgot_password', 'change_password', 'change_email'].includes(_vm.$route.name)}})],1),_c('Dialogs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }